import { render, staticRenderFns } from "./Projects.vue?vue&type=template&id=0626e5f7&scoped=true&v-for=(projectsTitle%2C%20index)%20in%20projectsTitle&%3Akey=index&"
import script from "./Projects.js?vue&type=script&lang=js&"
export * from "./Projects.js?vue&type=script&lang=js&"
import style0 from "./Projects.scss?vue&type=style&index=0&id=0626e5f7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0626e5f7",
  null
  
)

export default component.exports